export interface ICompanyList {
  list: ICompany[];
  count: number;
  totalPages: number;
}

export interface ICompanyFile {
  name?: string;
  key?: string;
  url?: string;
  path?: string;
  _id?: string;
  createdAt?: string;
  updatedAt?: string;
  /* Virtual property used only to store file to be uploaded */
  file?: File;
}

export interface ICompanyAdddress {
  cep: string;
  street: string;
  complement: string;
  number: string;
  neighborhood: string;
  city: string;
  state: string;
  location?: {
    type: 'Point';
    coordinates: string[];
    _id: string;
  };
  _id?: string;
  completeAddress?: string;
}

export interface ICompanyAccess {
  name: string;
  email: string;
  isSuperUser: boolean;
}

export interface ICompany {
  id?: string;
  _id?: string;
  contractType: CompanyContractTypeEnum | null;
  planType: CompanyPlanTypeEnum | null;
  cnpj?: string | null;
  socialReason: string;
  phone: string;
  mobilePhone: string;
  address?: ICompanyAdddress;
  documents?: ICompanyFile[] | null;
  users: ICompanyAccess[];
  planPrice: number;
}
export interface ICompanyCreate extends ICompany {
  /* files to be uploaded */
  documentsFiles: { file: File }[];
}

export enum CompanyContractTypeEnum {
  'coparticipation' = 'COPARTICIPATIVA',
  'companyFullPayment' = 'EMPRESA COM PAGAMENTO INTEGRAL',
  'tutorFullPayment' = 'COLABORADOR COM PAGAMENTO INTEGRAL',
}

export enum CompanyPlanTypeEnum {
  'healthPlan' = 'Plano de Saúde',
  'businessPlan' = 'Plano Empresarial',
}

export interface ICompanyHumanResourcesUser {
  id: string;
  name: string;
  email: string;
  isSuperUser: boolean;
  role: string;
  company: {
    companyId: string;
    contractType: string;
    socialReason: string;
  };
}

export const CompanyDefaultValues: ICompanyCreate = {
  contractType: null,
  cnpj: '',
  socialReason: '',
  planType: null,
  phone: '',
  mobilePhone: '',
  address: {
    cep: '',
    city: '',
    complement: '',
    number: '',
    neighborhood: '',
    street: '',
    state: '',
  },
  documents: [],
  documentsFiles: [],
  users: [{ email: '', name: '', isSuperUser: false }],
  planPrice: 0,
};
